<template>
  <div class="wrap-building">
    <!-- 楼栋分类 -->
    <div class="container" :class="searchVisible ? 'bg2' : ''">
      <div class="close-icon" @click="closeHandle">
        <span class="el-icon-close"></span>
      </div>
      <!-- 左侧楼栋菜单 -->
      <div class="building-left">
        <div class="title">
          <img src="/images/preloader/icon-build.png" alt="" />
          <span>查楼栋</span>
        </div>
        <div ref="menuList" class="list-wrap">
          <ul class="list">
            <li
              v-for="(item, index) in buildingList"
              :key="index"
              :class="
                curSelectBuildingIndex === index && searchKey.length === 0
                  ? 'active'
                  : ''
              "
              @click="selectBuilding(index)"
            >
              {{ item.polygonName }}
            </li>
          </ul>
        </div>
        <div class="btn-group">
          <div @click="scrollHandle('up')">
            <img src="/images/preloader/icon-up.png" alt="" /><span>上翻</span>
          </div>
          <div @click="scrollHandle('down')">
            <img src="/images/preloader/icon-down.png" alt="" /><span
              >下翻</span
            >
          </div>
        </div>
      </div>

      <!-- 中间楼栋选项 -->
      <div class="building-middle">
        <div class="btn-group-top">
          <div @click="searchSwitch">
            <img src="/images/preloader/icon_foot_search.png" alt="" /><span
              >拼音查找</span
            >
          </div>
        </div>
        <div class="content">
          <ul v-if="pinyinSearchList.length > 0" class="list">
            <li
              v-for="(item, index) in pinyinSearchList"
              :key="index"
              @click="selectPoi(item.poiItemId, item.poiName)"
            >
              {{ item.poiName }}
            </li>
          </ul>
          <noContent v-else-if="searchKey.length > 0"></noContent>

          <div v-else-if="curBuildingChilds.length > 0" class="list-group">
            <div v-for="(groupInfo, index) in curBuildingChilds" :key="index">
              <div class="list-group-title">{{ groupInfo.groupName }}</div>
              <ul class="list">
                <li
                  v-for="(poiInfo, index2) in groupObj[groupInfo.groupId][
                    'poiSearchList'
                  ]"
                  :key="index2"
                  @click="selectPoi(poiInfo.poiItemId, poiInfo.poiName)"
                >
                  {{ poiInfo.poiName }}
                </li>
              </ul>
            </div>
          </div>

          <noContent v-else></noContent>
        </div>

        <div class="btn-group">
          <div @click="closeHandle">
            <img src="/images/preloader/icon_foot_close.png" alt="" /><span
              >关闭</span
            >
          </div>
          <!-- <div @click="searchSwitch"><img src="/images/preloader/icon_foot_search.png" alt=""><span>拼音查找</span></div> -->
        </div>
      </div>

      <!-- 右侧拼音查找 -->
      <div v-show="searchVisible" class="building-right">
        <div class="title">拼音查找</div>
        <input
          v-model="searchKey"
          class="search-input"
          @input="enterSaver"
          disabled
          type="text"
        />
        <div class="letter-wrap">
          <div
            v-for="(item, index) in letterArr"
            :key="index"
            class="letter"
            @click="inputLetter(item)"
          >
            {{ item }}
          </div>
          <div class="letter" style="flex:1;" @click="deleteLetter">
            <img src="/images/preloader/icon_pingyin_deletion.png" alt="" />
            <span>回删</span>
          </div>
        </div>
        <div class="btn-group">
          <div @click="searchSwitch">
            <img src="/images/preloader/icon_foot_packup.png" alt="" /><span
              >收起</span
            >
          </div>
          <div class="close-btn" @click="closeHandle">
            <img src="/images/preloader/icon_foot_close.png" alt="" /><span
              >关闭</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import noContent from "@/components/no-content";

export default {
  components: {
    noContent
  },
  props: {},
  data() {
    return {
      searchVisible: false, // 拼音搜索显示状态
      detailVisible: false, // 楼栋详情窗口显示状态
      searchKey: "", // 拼音搜索关键字
      pinyinSearchList: [], // 拼音搜索结果
      buildingList: [], // 楼栋分类列表
      groupObj: {}, // 分组信息
      buildingDetailList: {}, // 楼栋详情
      curSelectBuildingIndex: 0 // 当前选择楼栋分类下标
    };
  },
  computed: {
    // 建筑信息
    buildInfo: {
      get() {
        return this.$store.state.nav.buildInfo;
      },
      set(val) {
        this.$store.commit("nav/set_buildInfo", val);
      }
    },
    // 楼栋分类子项
    curBuildingChilds() {
      console.log("buildingList", this.buildingList);
      if (
        this.buildingList[this.curSelectBuildingIndex] &&
        this.buildingList[this.curSelectBuildingIndex].poiGroupList
      ) {
        return this.buildingList[this.curSelectBuildingIndex].poiGroupList;
      } else {
        return [];
      }
    },
    // 功能模块
    FUN_MODULE() {
      return this.$store.state.app.FUN_MODULE;
    },
    ...mapState("app", ["letterArr"])
  },
  watch: {
    searchKey(val) {
      if (val.length > 0) {
        this.pinyinSearch(val);
      } else {
        this.pinyinSearchList = [];
      }
    },
    detailVisible(val) {
      if (!val) {
        this.buildingDetailList = {};
      }
    }
  },
  async mounted() {
    let buildingRes = await this.getBuildingList();
    let groupRes = await this.getGroupList();
    let groupObj = {};

    groupRes.forEach(item => {
      groupObj[item.groupId] = item;
    });
    this.buildingList = buildingRes;
    this.groupObj = groupObj;
  },
  methods: {
    // 选择楼栋分类
    selectBuilding(index) {
      console.log("选择楼栋分类", index);
      this.searchKey = "";
      this.curSelectBuildingIndex = index;
    },
    // 选择楼栋
    selectPoi(poiId, name) {
      this.$emit("selectPoi", poiId, name, this.FUN_MODULE.BUILDING);
      this.$emit("close");
    },
    // 上翻下翻
    scrollHandle(type) {
      console.log(this.$refs.menuList.scrollTop);
      let scrollTop = this.$refs.menuList.scrollTop;
      if (type === "up") {
        this.$refs.menuList.scrollTop = scrollTop - 600;
      } else {
        this.$refs.menuList.scrollTop = scrollTop + 600;
      }
    },
    // 拼音搜索开关
    searchSwitch() {
      this.searchVisible = !this.searchVisible;
    },
    // 输入字母
    inputLetter(letter) {
      this.searchKey += letter;
    },
    // 删除字母
    deleteLetter() {
      if (this.searchKey.length > 0) {
        this.searchKey = this.searchKey.substr(0, this.searchKey.length - 1);
      }
    },
    // 关闭楼栋窗口
    closeHandle() {
      this.$emit("close");
    },
    // 获取楼栋列表
    async getBuildingList(buildId = this.buildInfo.buildId) {
      try {
        let res = await this.$apis.nav.queryPolygonList({
          buildId: buildId
        });
        return JSON.parse(res.data);
      } catch (error) {
        console.error(error);
      }
    },
    // 获取POI分组列表
    async getGroupList(buildId = this.buildInfo.buildId) {
      try {
        let res = await this.$apis.nav.queryGroupList({
          buildId: buildId
        });
        return JSON.parse(res.data);
      } catch (error) {
        console.error(error);
      }
    },
    // 拼音搜索
    async pinyinSearch(search, buildId = this.buildInfo.buildId) {
      try {
        let res = await this.$apis.nav.pinyingPoi({
          buildId,
          search
        });
        let data = res.data ? JSON.parse(res.data) : [];
        this.pinyinSearchList = data;
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    ...mapActions("nav", [
      // 调用定时器
      "enterSaver"
    ])
  }
};
</script>

<style scoped lang="scss">
.wrap-building {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: $color-opacity-regular;

  //楼栋列表
  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 100%;
    transform: translate(-50%, -50%);
    background: url("/images/preloader/bg-symptom1.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    padding: 5px 10px 12px 8px;
    box-sizing: border-box;
    .close-icon {
      display: none;
    }
  }
  .bg2 {
    background: url("/images/preloader/bg-symptom2.png") no-repeat;
    background-size: 100% 100%;
  }
  .building-left {
    width: 295px;
    color: $color-white;
    .title {
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      img {
        margin: 0 10px 0 0;
        width: 37px;
      }
    }
    .list-wrap {
      height: calc(100% - 220px);
      overflow: auto;
      .list {
        list-style: none;
      }
      li {
        font-size: 26px;
        height: 70px;
        line-height: 70px;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .active {
        background: #386998;
        color: #40e9ad;
        border-left: 5px solid #40e9ad;
      }
    }
    .btn-group {
      flex: 0 0 wrap;
      display: flex;
      height: 100px;
      align-items: center;
      justify-content: space-evenly;
      & > div {
        width: 100px;
        height: 40px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        border-radius: 50px;
        // margin: 0 40px 0 0;
        color: $color-white;
      }
      img {
        margin: 0 10px 0 0;
        width: 24px;
      }
    }
  }
  .building-middle {
    width: 1160px;
    padding: 40px 0 40px 0;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .content {
      height: 100%;
      overflow: hidden;
    }
    .list-group {
      height: calc(100% - 20px);
      overflow-y: scroll;
      &-title {
        color: #eee;
        font-size: 28px;
        text-align: left;
        padding: 0px 30px 20px 40px;
        position: relative;
        &::after {
          position: absolute;
          top: 6px;
          left: 25px;
          content: "";
          width: 5px;
          height: 20px;
          background: #40e9ad;
          border-radius: 5px;
        }
      }
    }
    .list {
      color: $color-white;
      font-size: 28px;
      width: 100%;
      height: 100%;
      overflow: auto;
      text-align: left;
      padding-bottom: 100px;
    }
    li {
      display: inline-block;
      height: 80px;
      line-height: 80px;
      box-sizing: border-box;
      padding: 0 40px;
      margin: 0 16px 20px;
      background: linear-gradient(#1cb4fb, #048ae8);
      border-radius: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .btn-group {
      position: relative;
      display: flex;
      flex-direction: row-reverse;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        margin: 0 40px 0 0;
        color: $color-white;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
    }
    .btn-group-top {
      position: relative;
      display: flex;
      padding-bottom: 40px;
      margin-left: 16px;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        margin: 0 40px 0 0;
        color: $color-white;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
    }
  }
  .building-right {
    position: relative;
    width: 385px;
    margin: 40px 0 40px 0;
    border-left: 1px solid #618aaf;
    .title {
      font-size: 28px;
      color: $color-white;
      width: 306px;
      margin: 0 auto 40px;
      text-align: left;
    }
    .search-input {
      border: 1px solid #618aaf;
      border-radius: 10px;
      width: 306px;
      height: 50px;
      line-height: 50px;
      margin: 0 auto;
      text-align: left;
      color: $color-white;
      font-size: 26px;
      padding: 0 20px;
      box-sizing: border-box;
      background: transparent;
    }
    .letter-wrap {
      display: flex;
      flex-wrap: wrap;
      border: 1px solid #618aaf;
      border-radius: 10px;
      overflow: hidden;
      width: 306px;
      margin: 10px auto 0;
      .letter {
        width: 50px;
        height: 50px;
        line-height: 50px;
        border: 1px solid #618aaf;
        // box-sizing: border-box;
        margin: -1px 0 0 -1px;
        color: $color-white;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
          background: #345b85;
        }
        img {
          margin: 0 10px 0 0;
        }
      }
    }
    .btn-group {
      display: flex;
      flex-direction: row-reverse;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      justify-content: center;
      & > div {
        width: 180px;
        height: 60px;
        background: #3a6191;
        box-shadow: 0 0 10px $color-opacity-primary;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        border-radius: 50px;
        color: $color-white;
      }
      .close-btn {
        display: none;
      }
      img {
        margin: 0 20px 0 0;
        width: 24px;
      }
    }
  }
}

.buildingPop {
  height: 660px;
  padding: 20px 0;
  box-sizing: border-box;
  .content {
    height: 100%;
    overflow-y: scroll;
    box-sizing: border-box;
  }
  .building-wrap {
    margin: 0 0 20px 0;
    .building-cate {
      font-size: 36px;
      color: #fff;
      text-align: left;
      margin: 0 0 20px 28px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .building-list {
      display: flex;
      flex-wrap: wrap;
      color: $color-white;
      font-size: 28px;
      // flex: 1;
      align-content: flex-start;
      height: 100%;
      width: 100%;
      overflow: auto;
    }
    .building-li {
      width: 258px;
      height: 98px;
      line-height: 80px;
      box-sizing: border-box;
      padding: 5px 20px 10px 18px;
      margin: 0 17.5px 20px;
      text-align: center;
      background: url("/images/preloader/btn-bg1.png");
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
@media (orientation: portrait) {
  .wrap-building {
    .container {
      height: 68vh;
      padding: 0;
      // background-size: auto 100%;
      background: rgba(46, 90, 141, 0.94);
      border-radius: 20px;
      .close-icon {
        display: block;
        position: absolute;
        top: -60px;
        right: 0;
        font-size: 38px;
        color: #ccc;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border-radius: 50%;
        border: 2px solid #ccc;
        padding: 0;
        font-weight: bold;
        box-sizing: border-box;
      }
    }
    .building-middle {
      background: #476f9b;
      border-radius: 0 20px 20px 0;
      .content {
        height: calc(100% - 620px);
      }
      .list {
        height: calc(100% - 620px);
        padding: 0;
      }
      .btn-group {
        display: none;
      }
      .btn-group-top {
        display: none;
      }
    }
    .building-left {
      .btn-group {
        & > div {
          width: 120px;
          height: 50px;
          font-size: 20px;
        }
      }
    }
    .building-right {
      position: absolute;
      margin: 0;
      height: 600px;
      width: 1160px;
      bottom: 0;
      right: 0;
      display: block !important;
      border: 0;
      .title {
        text-align: center;
        margin: 0 auto 10px;
      }
      .search-input {
        width: 936px;
        height: 70px;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .letter-wrap {
        width: 936px;
        .letter {
          width: 70px;
          height: 70px;
          font-size: 30px;
          img {
            width: 20px;
          }
        }
      }
      .btn-group {
        position: absolute;
        right: 30px;
        left: auto;
        bottom: 40px;
        width: 200px;
        div:nth-of-type(1) {
          display: none;
        }
        .close-btn {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
